// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2rWiP","file":"styles_file__2UMMa"};